import { FormTransformations } from "../../../types/ProductService/ProductService";
import abstractLitigationCaseTransformations from "./abstractLitigationCaseTransformations";

const contractTransformations: FormTransformations = {
  dateFields: [
    ...abstractLitigationCaseTransformations.dateFields!,
    { path: "bookingDate", type: "date" },
    { path: "buyerPaidDate", type: "date" },
    { path: "cancellationDate", type: "date" },
    { path: "contractualPartnerCancellationDate", type: "date" },
    { path: "costEstimateAdjustmentDate", type: "date" },
    { path: "defectsRecognitionDate", type: "date" },
    { path: "endOfContractDate", type: "date" },
    { path: "endOfContractDateOpponent", type: "date" },
    { path: "eventDate", type: "date" },
    { path: "goodsOrServiceProvidedDate", type: "date" },
    { path: "journeyStart", type: "date" },
    { path: "journeyEnd", type: "date" },
    { path: "serviceUnavailableFromDate", type: "date" },
    { path: "serviceUnavailableToDate", type: "date" },
    { path: "client.birthDate", type: "date" },
    { path: "cancellationReceivedDate", type: "date" },
    { path: "priceIncreaseAnnouncementDate", type: "date" },
    { path: "specialTerminationDate", type: "date" },
  ],
  numberFields: [
    ...abstractLitigationCaseTransformations.numberFields!,
    "numberRepairAttempts",
    "numberReplacementAttempts",
    "numberDaysAvailableInBetween",
    "numberUnpaidPeriods",
    "numberOfTickets",
    "mileageAtPurchase",
    "currentMileage",
    "kilometersDriven",
    "expectedTotalMileage",
  ],
  timeFields: abstractLitigationCaseTransformations.timeFields!,
  floatFields: [
    ...abstractLitigationCaseTransformations.floatFields!,
    "fee",
    "purchasePrice",
    "buyerPaidAmount",
    "costReal",
    "costEstimate",
  ],
  ibanFields: abstractLitigationCaseTransformations.ibanFields!,
  entityIriFields: abstractLitigationCaseTransformations.entityIriFields,
};
export default contractTransformations;
